"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssetImg = exports.GalleryAssetCardContainer = exports.GalleryAssetsContainer = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const styled_breakpoints_1 = require("styled-breakpoints");
exports.GalleryAssetsContainer = styled_components_1.default.div `
	width: 100%;
	display: flex;
	flex-wrap: wrap;
	margin: 1rem 0;
	gap: 1rem;

	${(0, styled_breakpoints_1.down)('sm')} {
		width: auto;
		flex-wrap: nowrap;
		overflow-x: auto;
		gap: 0.25rem;
	}
`;
exports.GalleryAssetCardContainer = styled_components_1.default.div `
	width: 100px;
	height: 100px;
	border-radius: ${props => props.theme.borderRadius.base};
	background-color: ${props => props.theme.color.gray9};
	box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px;
	cursor: pointer;
	margin-bottom: 0.25rem;
	${(0, styled_breakpoints_1.down)('sm')} {
		flex-shrink: 0;
		border-radius: 2px;
	}
`;
exports.AssetImg = styled_components_1.default.img `
	width: 100%;
	height: 100%;
	border-radius: inherit;
	object-fit: cover;
`;
